import { tv } from 'tailwind-variants'

export const chatDrawerVariants = tv({
  slots: {
    containerHeader: 'flex flex-row max-w-[30vw] min-w-[30vw] items-center py-deca justify-between',
    containerHeaderTitle: 'ml-mega h-full w-full flex-row text-center items-center',
    title: 'text-h3 font-bold text-secondary-dark',
    buttonClose: 'mr-deca',
    buttonIcon: 'flex text-deca',
    containerChildren: 'max-w-[30vw] min-w-[30vw]'
  }
})
